import Api from '../Api';

class PhoneApi extends Api {
  constructor() {
    super('phoneTypes', 'phoneTypes');
  }
}
const phoneApi = new PhoneApi();
export default phoneApi;
